export default __webpack_public_path__ + "fd45ff44475a9964e4edf984886ac0f9.svg";